import React, { JSX } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    DateInput,
    useNotify,
    useRedirect,
    SelectArrayInput,
    BooleanInput,
    useCreate, SimpleFormIterator, ArrayInput
} from 'react-admin';
import {
    Grid
} from '@mui/material'
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";
export const EnterpriseRequestCreate: () => JSX.Element = (): JSX.Element => {
    const today: Date = new Date();
    const dateString: string = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;

    return (
        <Create redirect="list">
            <SimpleForm>
                <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                    <Grid size={ 6 }>
                        <TextInput name="name" source="name" validate={[required()]} fullWidth />
                        <TextInput name="email" source="email" validate={[required()]} fullWidth />
                        <TextInput name="telephone" source="telephone" validate={[required()]} fullWidth />
                        <TextInput name="website"
                                   helperText="Include the https:// in the domain"
                                   source="website"
                                   validate={[required()]}
                                   fullWidth />
                    </Grid>
                    <Grid size={ 6 }>
                        <ArrayInput name="notes" source="notes" label="Notes">
                            <SimpleFormIterator >
                                <DateInput name="date"
                                           readOnly
                                           defaultValue={ dateString }
                                           source="date"  />
                                <TextInput name="note"
                                           source="note"
                                           helperText="Notes are internal"
                                           fullWidth
                                           multiline
                                           rows={24}/>
                            </SimpleFormIterator>
                        </ArrayInput>
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}